import * as ActionType from "./delivery.type";

const initialState = {
  delivery: [],
};

export const deliveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_DELIVERY:
      return {
        ...state,
        delivery: action.payload,
      };

    case ActionType.CREATE_DELIVERY:
      return {
        ...state,
        delivery: [action.payload, ...state.delivery],
      };

    case ActionType.UPDATE_DELIVERY:
      return {
        ...state,
        delivery: state.delivery.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    case ActionType.DELETE_DELIVERY:
      return {
        ...state,
        delivery: state.delivery.filter(
          (item) => item._id !== action.payload.id
        ),
      };

    case ActionType.TOGGLE_DELIVERY:
      return {
        ...state,
        delivery: state.delivery.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    default:
      return state;
  }
};